import {Injectable} from '@angular/core';
import {FinanceService} from '../../../finance/finance.service';
import {SnackBarService} from '../../../services/snackbar.service';


export const OBJECT_TEST = {
  'response': {
    'result': {
      'currency': 'EUR',
      'endingBalance': 192.34,
      'iban': 69202208000022902859,
      'openingBalance': 0.0,
      'transactions': [
        {
          'amount': -1604.17,
          'date': '2024-01-21',
          'description': 'Payout to ESTUDIO LABORALISTA MCT S.L.'
        },
        {
          'amount': -497.08,
          'date': '2024-01-21',
          'description': 'Payout'
        },
        {
          'amount': 304.74,
          'date': '2024-01-23',
          'description': 'Payout to ETM Corporate Services B.V'
        },
        {
          'amount': -192.34,
          'date': '2024-01-31',
          'description': 'Ending balance'
        },
        {
          'amount': 5000.0,
          'date': '2024-01-21',
          'description': 'Transfer from Riseup Moments LTD'
        },
        {
          'amount': -2598.75,
          'date': '2024-01-21',
          'description': 'Payout to ESTUDIO LABORALISTA MCT S.L.'
        },
        {
          'amount': 110.0,
          'date': '2024-01-21',
          'description': 'Payout to Gabinete Martinez Comin SA'
        },
        {
          'amount': -2.40125,
          'date': '2024-01-21',
          'description': 'Payout'
        },
        {
          'amount': 20.0,
          'date': '2024-01-21',
          'description': 'Payout to ESTUDIO LABORALISTA MCT S.L.'
        },
        {
          'amount': -2.27125,
          'date': '2024-01-21',
          'description': 'Payout'
        },
        {
          'amount': 20.0,
          'date': '2024-01-21',
          'description': 'Payout to ESTUDIO LABORALISTA MCT S.L.'
        },
        {
          'amount': -2.25125,
          'date': '2024-01-21',
          'description': 'Payout'
        },
        {
          'amount': 150.0,
          'date': '2024-01-21',
          'description': 'Payout to ESTUDIO LABORALISTA MCT S.L.'
        }
      ]
    },
    'valid_json': true
  }
};

@Injectable()
export class BankStatementController {
  constructor(private financeService: FinanceService, private snackBarService: SnackBarService) {
  }

  saveBankStatement(file: File, bankAccountId: number, onComplete: (response: any, success: boolean) => void) {
    this.financeService.saveBankStatementDocument(file, bankAccountId).subscribe({
      next: (response: any) => {
        this.showSimpleMsh('Bank statement saved successfully.');
        onComplete(response.arrResult, true);
      },
      error: (err) => this.showSimpleMsh('Cannot save bank statement with Error :: ' + err.message)
    });
  }

  getDocumentAnalysis(
    documentName: string,
    bankAccountId: number,
    tenantId: number,
    onComplete: (response: any, analyzedDocument: boolean) => void,
    bankStatementId?: number
  ) {
    this.financeService.getDocumentAnalysis(documentName, bankAccountId, tenantId, bankStatementId).subscribe({
      next: (response: any) => {
        // Check response structure - could be direct response or wrapped in arrResult
        const responseData = response.arrResult || response;
        
        // If processing asynchronously
        if (responseData.status === 'processing') {
          this.showSimpleMsh('Document analysis started. Processing in background...');
          onComplete(responseData, false); // Pass status info but don't trigger completion
        } else if (responseData.status === 'failed') {
          // Analysis failed to start
          this.showSimpleMsh('Failed to start document analysis: ' + (responseData.message || 'Unknown error'));
          onComplete(responseData, false);
        } else {
          // Legacy synchronous processing or completed analysis
          this.showSimpleMsh('Analysis document successfully.');
          onComplete(responseData, true);
        }
      },
      error: (e) => {
        this.showSimpleMsh('Error trying to analyze document with Error :: ' + e.message);
        // Return error status
        onComplete({status: 'failed', error: e.message}, false);
      }
    });
  }

  saveJsonObject(json: any, bankStatementId: number, onComplete: (success: boolean) => void, message?: string, errorMessage?: string) {
    if (!message) {
      message = 'Analysis data saved successfully.';
    }
    if (!errorMessage) {
      errorMessage = 'Cannot save Analysis data';
    }
    this.financeService.saveBankStatementJsonObject(json, bankStatementId).subscribe({
      next: () => {
        this.showSimpleMsh(message);
        onComplete(true);
      },
      error: (err) => {
        this.showSimpleMsh(errorMessage);
        onComplete(false);
      }
    });
  }

  private showSimpleMsh(msj: string) {
    this.snackBarService.showSimpleMsj(msj);
  }
  deleteBankStatement(id: string, onComplete: (success: boolean) => void) {
    this.financeService.deleteBankStatement(id).subscribe({
      next: () => {
        this.showSimpleMsh('Bank statement deleted successfully.');
        onComplete(true);
      },
      error: (err) => {
        console.log(err);
        this.showSimpleMsh('Cannot delete bank statement with Error :: ');
        onComplete(false);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/finance/bank-statement/bank-statement.controller.ts